import { alpha, Components, Theme } from "@mui/material/styles";
import { textFieldHeight } from "../../va-package/ui/input/interface";

export default function TextField(theme: any) {
  const textfield: Components<Theme>["MuiTextField"] = {
    styleOverrides: {
      root: ({ theme }: any) => ({
        "& .MuiOutlinedInput-root": {
          borderRadius: "10px",
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
          "&.Mui-focused": {
            backgroundColor: theme.palette.background.default,
            boxShadow: `${theme.palette.primary.main} 0px 0px 0px 1px`,
          },
          "& fieldset": {
            border: "unset",
          },
          "&:hover": {
            background: "var(--background-default-hover)",
          },
          "&.Mui-error": {
            backgroundColor: alpha(theme.palette.error.main, 0.2),
            color: `${theme.palette.error.main}`,
          },
        },
        "& .MuiOutlinedInput-input": {
          fontSize: 14,
          padding: "unset",
          height: textFieldHeight,
          color: theme.palette.text.primary,
          paddingLeft: 12,
          paddingRight: 12,
          fontWeight: 400,
          "&.Mui-disabled": {
            fontSize: 14,
            fontWeight: 400,
            color: theme.palette.text.disabled,
            WebkitTextFillColor: theme.palette.text.disabled,
            cursor: "no-drop",
          },

          "&.Mui-error": {
            color: theme.palette.error.main,
            fontWeight: 300,
          },
          "&:-webkit-autofill": {
            WebkitTextFillColor: theme.palette.text.primary,
            WebkitFillColor: "transparent !important",
            background: "transparent !important",
          },
          "&::placeholder": {
            fontSize: 14,
            fontWeight: 400,
            color: theme.palette.text.disabled,
            opacity: 0.8,
          },
        },
        "&.MuiFormHelperText-root": {
          marginLeft: 0,
        },
      }),
    },
    variants: [],
  };
  return {
    MuiTextField: { ...textfield },
  };
}
